import { createContext, useContext } from 'react';

/** DOM node of the top app-bar's right-hand actions area (App.tsx). A page can
 *  portal controls into the top bar by rendering into this element, instead of
 *  carrying its own header block. Null until the bar has mounted. */
export const HeaderActionsContext = createContext<HTMLElement | null>(null);

export function useHeaderActionsEl(): HTMLElement | null {
  return useContext(HeaderActionsContext);
}

/** DOM node of the top app-bar's LEFT title area — right next to the back
 *  arrow (App.tsx). A page with no static TOPBAR title (e.g. a detail page)
 *  portals its own title here so it sits beside the arrow, not on the right. */
export const HeaderTitleContext = createContext<HTMLElement | null>(null);

export function useHeaderTitleEl(): HTMLElement | null {
  return useContext(HeaderTitleContext);
}
